import { Check, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { SORT_OPTIONS, type SortId } from '@/components/job-feed/jobFeed.types';
import { Button } from '@/components/ui/Button';
import { cx } from '@/cva.config';

interface SortMenuProps {
  onChange: (value: SortId) => void;
  value: SortId;
}

export const SortMenu = ({ value, onChange }: SortMenuProps) => {
  const [open, setOpen] = useState(false);
  const current = SORT_OPTIONS.find((o) => o.id === value);
  return (
    <div className="relative">
      <Button onClick={() => setOpen((o) => !o)} size="sm" variant="outline">
        Sort: {current?.label}
        <ChevronDown className="size-3" />
      </Button>
      {open && (
        <>
          <button
            className="fixed inset-0 z-10"
            onClick={() => setOpen(false)}
            type="button"
          />
          <div className="absolute top-9 right-0 z-20 w-44 animate-fadeIn rounded-md border border-border bg-surface shadow-xl">
            {SORT_OPTIONS.map((option) => (
              <button
                className={cx(
                  'flex w-full items-center justify-between px-3 py-1.5 text-left text-xs lg:text-sm',
                  option.id === value
                    ? 'text-accent'
                    : 'text-foreground hover:bg-border/40',
                )}
                key={option.id}
                onClick={() => {
                  onChange(option.id);
                  setOpen(false);
                }}
                type="button"
              >
                {option.label}
                {option.id === value && <Check className="size-3" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
